import Systems from './getters/Systems';
import JSInstances from './getters/JSInstances';
import B2b from './getters/B2b';
import UserAnalytics from './getters/UserAnalytics';
import User from './getters/User';
import Orders from './getters/Orders';
import Cart from './getters/Cart';

export default {
  ...JSInstances,
  ...Cart,
  ...Orders,
  ...User,
  ...UserAnalytics,
  ...B2b,
  ...Systems
};
